"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuHeading = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _DropdownHeading = require("../DropdownHeading/DropdownHeading");
/**
 * The `Menu` component is usually limited to a list of `MenuItem` actions, but you can add
 * a heading with this component.
 *
 * @extends DropdownHeading
 * @since 8.61.0
 */
var MenuHeading = /*#__PURE__*/(0, _styledComponents.default)(_DropdownHeading.DropdownHeading).withConfig({
  displayName: "MenuHeading",
  componentId: "c11n-8-101-0__sc-prckc5-0"
})([""]);
exports.MenuHeading = MenuHeading;
MenuHeading.displayName = 'MenuHeading';

/** @component */